var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNegotiation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 4.72223C10.0019 5.45549 9.83058 6.17883 9.49999 6.83334C9.108 7.61764 8.5054 8.27732 7.75968 8.73849C7.01396 9.19966 6.15457 9.44411 5.27777 9.44445C4.54451 9.44636 3.82117 9.27504 3.16666 8.94445L0 10L1.05555 6.83334C0.724961 6.17883 0.553643 5.45549 0.555555 4.72223C0.555894 3.84543 0.800339 2.98604 1.26151 2.24032C1.72268 1.4946 2.38236 0.891996 3.16666 0.500015C3.82117 0.169422 4.54451 -0.00189598 5.27777 1.58267e-05H5.55555C6.71352 0.0639 7.80723 0.55266 8.62729 1.37271C9.44734 2.19277 9.9361 3.28648 9.99998 4.44445V4.72223Z",
    fill: "#333541"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegotiation);
export default __webpack_public_path__ + "static/media/negotiation.4f149a3bd7e05d3833634037d916785e.svg";
export { ForwardRef as ReactComponent };